export default {
  SMALL: 10,
  MEDIUM: 11
}
